<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Opomene ({{ totalRecords }}) Ukupno: {{ totalPrice }} EUR, Placeno: {{
                            totalPayed }} EUR, Ponisteno: {{ totalCanceled }}</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.start">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.end">
                                </el-date-picker>
                            </base-input>
                        </div>

                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input v-model="filter.plates" />
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Delovodni broj</h4>
                            <base-input v-model="filter.warningCode" />
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.status" class="select-primary" name="zone" clearable
                                    @clear="clearStatus">
                                    <el-option v-for="zone in statuses" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tip opomene</h4>
                            <base-input>
                                <el-select v-model="filter.warningType" class="select-primary" name="zone" clearable
                                    @clear="clearWarningType">
                                    <el-option v-for="zone in warningTypes" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Iznos od</h4>
                            <base-input v-model="filter.amountMin" type="number" placeholder="Min" />
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Iznos do</h4>
                            <base-input v-model="filter.amountMax" type="number" placeholder="Max" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <base-checkbox class="text-left" v-model="filter.showCanceled">
                                Prikazi ponistene opomene
                            </base-checkbox>
                        </div>

                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"></h4>
                            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="getWarnings()">Pretraži</base-button>

                            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="getWarningsReport()">EXCEL</base-button>
                            <!-- </card> -->
                        </div>

                    </div>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="newWarning1()">Nova PRVA opomena</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="newWarning2()">Nova DRUGA opomena</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="izvrsenje()">Izvršenje</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="savePostReturned()">Vraćena pošta</base-button>

                    <el-table :data="warnings" v-loading="ticketsLoading">

                        <el-table-column min-width="30" prop="checked" label="">
                            <template slot-scope="scope">
                                <span>
                                    <base-checkbox class="text-left" @input="warningChecked(scope.row)"
                                        v-model="scope.row.checked">

                                    </base-checkbox>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plateOwner.name }} {{ scope.row.plateOwner.lastName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="warningCode" label="Delovodni broj">
                            <template slot-scope="scope">
                                <span>{{ scope.row.warningCode }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="warningType" label="Tip opomene">
                            <template slot-scope="scope">
                                <span v-if="scope.row.warningType === 0">PRVA OPOMENA</span>
                                <span v-if="scope.row.warningType === 1">DRUGA OPOMENA</span>
                                <span v-if="scope.row.warningType === 2">IZVRŠENJE</span>

                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="totalPrice" label="Ukupan iznos">
                            <template slot-scope="scope">
                                <span>{{ scope.row.totalAmount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="payedPrice" label="Plaćeno">
                            <template slot-scope="scope">
                                <span style="color: green;">{{ scope.row.payed }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="cancelPrice" label="Poništeno">
                            <template slot-scope="scope">
                                <span>{{ scope.row.canceled }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="finished" label="Završeno">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 1" style="color: green;">DA</span>
                                <span v-if="scope.row.status === 2" style="color: orange;">KREIRANA NOVA OPOMENA</span>
                                <span v-if="scope.row.status === 0" style="color: red;">NE</span>

                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="finished" label="Pošta">
                            <template slot-scope="scope">
                                <span v-if="scope.row.postReturned" style="color: red;">VRAĆENA</span>

                            </template>
                        </el-table-column>

                        <el-table-column min-width="120" prop="finished" label="KP Ugovor">
                            <template slot-scope="scope">
                                <div v-if="scope.row.kupoprodajniUgovor">
                                    <span style="color: green;">{{ scope.row.brojKupoprodajnogUgovora }}</span>
                                    <br>
                                    <a :href="fileUrl + '/contracts/' + scope.row.id + '/' + scope.row.kupoprodajniUgovor"
                                        target="_blank"
                                        style="color: #e14eca; text-decoration: underline; cursor: pointer;">
                                        Preuzmi
                                    </a>
                                </div>
                            </template>
                        </el-table-column>


                        <el-table-column min-width="80" prop="stampLong" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">

                                <base-button :type="'success'" class="btn-link"
                                    @click="warning = scope.row; download()">
                                    Dokument
                                </base-button>

                                <base-button :type="'success'" class="btn-link" @click="getWarning(scope.row)">
                                    Detalji
                                </base-button>

                                <base-button v-if="!scope.row.warningCanceled && scope.row.status === 0"
                                    :type="'danger'" class="btn-link" @click="cancelWarning(scope.row)">
                                    Poništi
                                </base-button>

                            </div>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span>
                        <base-pagination class="pagination-no-border" v-model="filter.page" :per-page="filter.max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>


        <modal :show.sync="showWarning" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showWarning = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Opomena">

                <el-table :data="warning.tickets">

                    <el-table-column min-width="140" prop="stamp" label="Datum" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ (new Date(scope.row.ticket.stampLong)).toLocaleString("de-DE") }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="100" prop="client" label="Zona">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ticket.client">{{ scope.row.ticket.client.name }}</span>
                        </template>
                    </el-table-column>


                    <el-table-column min-width="100" prop="plates" label="Tablice" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ scope.row.ticket.plates }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="60" prop="price" label="Cena" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ scope.row.ticket.price }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="150" prop="paymentStatus" label="Status">
                        <template slot-scope="scope" v-if="scope.row.ticket.paymentStatus">
                            <span v-if="scope.row.ticket.paymentStatus.id === '2'" style="color: red">{{
                                scope.row.ticket.paymentStatus.name }}</span>
                            <span v-else-if="scope.row.ticket.paymentStatus.id === '1'" style="color: green">{{
                                scope.row.ticket.paymentStatus.name }}</span>
                            <span v-else>{{ scope.row.ticket.paymentStatus.name }}</span>


                        </template>
                    </el-table-column>

                    <el-table-column min-width="100" prop="ticket_number" label="ID" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ scope.row.ticket.ticketNumber }}</span>
                        </template>
                    </el-table-column>



                </el-table>
            </card>
            <card>
                <!-- <base-button :type="'primary'" size="sm" class="btn-link" @click="showWarning = false;">
                    Vraćena pošta
                </base-button> -->
                <base-button :type="'primary'" size="sm" class="btn-link" @click="showContract = true;">
                    Kupoprodajni ugovor
                </base-button>
            </card>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showWarning = false;">
                Zatvori
            </base-button>
        </modal>

        <modal :show.sync="showContract" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content-wide" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showContract = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Kupoprodajni ugovor">
                <div class="row">
                    <div class="col-md-6">
                        <base-input label="Broj ugovora" v-model="contractNumber" placeholder="Unesite broj ugovora" />
                    </div>
                </div>

                <h4 class="mt-4" style="color: #e14eca;">Podaci o novom vlasniku</h4>
                <div class="row">
                    <div class="col-md-4">
                        <base-input label="Tablice" type="text" v-model="newOwner.plates" placeholder="Tablice">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Matični broj" type="text" v-model="newOwner.personalNumber"
                            placeholder="Matični broj">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Prezime" type="text" v-model="newOwner.lastName" placeholder="Prezime">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Ime" type="text" v-model="newOwner.name" placeholder="Ime">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Ime oca" type="text" v-model="newOwner.fatherName" placeholder="Ime oca">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="PIB" type="text" v-model="newOwner.pib" placeholder="PIB">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Država" type="text" v-model="newOwner.country" placeholder="Država">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Grad" type="text" v-model="newOwner.city" placeholder="Grad">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Adresa" type="text" v-model="newOwner.address" placeholder="Adresa">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Poštanski broj" type="text" v-model="newOwner.postNumber"
                            placeholder="Poštanski broj">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Datum dobijanja podataka">
                            <el-date-picker type="date" placeholder="Datum dobijanja podataka" value-format="timestamp"
                                format="dd.MM.yyyy." v-model="newOwner.stamp">
                            </el-date-picker>
                        </base-input>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-12">
                        <h4 class="card-title">Dokument</h4>
                        <div class="upload-area" :class="{ 'drag-over': isDragging }"
                            @dragover.prevent="isDragging = true" @dragleave.prevent="isDragging = false"
                            @drop.prevent="handleDrop" @click="$refs.fileInput.click()">
                            <input ref="fileInput" type="file" @change="handleFileUpload" style="display: none;" />
                            <div v-if="!selectedFile" class="upload-placeholder">
                                <i class="tim-icons icon-cloud-upload-94" style="font-size: 48px; color: #e14eca;"></i>
                                <p style="color: white;">Prevucite fajl ovde ili kliknite za odabir</p>
                                <small class="text-muted">Svi tipovi dokumenata</small>
                            </div>
                            <div v-else class="selected-file">
                                <i class="tim-icons icon-paper" style="font-size: 32px; color: #00f2c3;"></i>
                                <div class="file-info">
                                    <span class="file-name">{{ selectedFile.name }}</span>
                                    <small class="text-muted">{{ formatFileSize(selectedFile.size) }}</small>
                                </div>
                                <base-button type="danger" size="sm" icon @click.stop="removeFile">
                                    <i class="tim-icons icon-simple-remove"></i>
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
            <div class="modal-footer">
                <base-button type="secondary" size="sm" @click="showContract = false;">
                    Zatvori
                </base-button>
                <base-button type="success" size="sm" @click="uploadContract" :disabled="uploading">
                    <span v-if="uploading"><i class="tim-icons icon-refresh-02 spin"></i> Čuvanje...</span>
                    <span v-else><i class="tim-icons icon-check-2"></i> Sačuvaj</span>
                </base-button>
            </div>
        </modal>

    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option, Card } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const statuses = [
    { id: 0, name: "NEZAVRSENO" },
    { id: 1, name: "ZAVRSENO" }
]

const warningTypes = [
    { id: 0, name: "PRVA OPOMENA" },
    { id: 1, name: "DRUGA OPOMENA" },
    { id: 2, name: "IZVRŠENJE" }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        this.getUserPageFilter()
        // this.getClients()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endDate = new Date(now); // Kopija trenutnog datuma
        endDate.setDate(now.getDate() + 7); // Dodajemo 7 dana
        endDate.setHours(23, 59, 59, 999); // Postavljamo poslednju sekundu dana
        const end = endDate.getTime();

        return {
            warningTypes,
            statuses,
            url: 'https://budva.scancar.org:8443/kuca',
            ticketsLoading: false,
            loading: false,
            warnings: [],
            warning: {},
            showWarning: false,
            filter: {
                start: start,
                end: end,
                sortField: "stamp",
                sortOrder: "descending",
                page: 1,
                max: 10,
                status: null,
                warningCode: null,
                plates: null,
                warningType: null,
                showCanceled: false,
                amountMin: null,
                amountMax: null
            },
            fileUrl: 'https://budva.scancar.org:8443',

            totalRecords: 0,
            totalPages: 0,
            totalPrice: 0,
            totalPayed: 0,
            totalCanceled: 0,
            comment: null,
            warningTickets: [],
            showContract: false,
            file: null,
            selectedFile: null,
            isDragging: false,
            uploading: false,
            contractNumber: null,
            newOwner: {
                plates: '',
                personalNumber: '',
                lastName: '',
                name: '',
                fatherName: '',
                pib: '',
                country: '',
                city: '',
                address: '',
                postNumber: '',
                stamp: new Date().getTime()  // Default današnji datum
            }
        };
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
            }
        },

        handleDrop(event) {
            this.isDragging = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.selectedFile = file;
            }
        },

        removeFile() {
            this.selectedFile = null;
            this.$refs.fileInput.value = '';
        },

        formatFileSize(bytes) {
            if (bytes < 1024) return bytes + ' B';
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
            return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
        },

        async uploadContract() {
            this.uploading = true;

            const formData = new FormData();
            if (this.selectedFile) {
                formData.append('file', this.selectedFile);
            }
            formData.append('warningId', this.warning.id);
            formData.append('contractNumber', this.contractNumber || '');

            // Podaci o novom vlasniku
            formData.append('ownerPlates', this.newOwner.plates || '');
            formData.append('ownerName', this.newOwner.name || '');
            formData.append('ownerLastName', this.newOwner.lastName || '');
            formData.append('ownerFatherName', this.newOwner.fatherName || '');
            formData.append('ownerPersonalNumber', this.newOwner.personalNumber || '');
            formData.append('ownerPib', this.newOwner.pib || '');
            formData.append('ownerCountry', this.newOwner.country || '');
            formData.append('ownerCity', this.newOwner.city || '');
            formData.append('ownerAddress', this.newOwner.address || '');
            formData.append('ownerPostNumber', this.newOwner.postNumber || '');
            formData.append('ownerStamp', this.newOwner.stamp || '');

            try {
                const result = await axios.post(this.url + '/ticket/uploadContract', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Ugovor uspešno sačuvan!',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });

                    this.showContract = false;
                    this.selectedFile = null;
                    this.contractNumber = null;
                    // Reset newOwner
                    this.newOwner = {
                        plates: '',
                        personalNumber: '',
                        lastName: '',
                        name: '',
                        fatherName: '',
                        pib: '',
                        country: '',
                        city: '',
                        address: '',
                        postNumber: '',
                        stamp: new Date().getTime()
                    };
                    this.getWarnings();
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }

            } catch (error) {
                this.$notify({
                    message: 'Greška prilikom čuvanja ugovora',
                    timeout: 3000,
                    icon: 'tim-icons icon-alert-circle-exc',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'danger'
                });
            } finally {
                this.uploading = false;
            }
        },
        getUserPageFilter() {
            this.loading = true

            axios.get(this.url + '/settings/getUserPageFilter?page=9').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                } else {
                    // this.$notify({
                    //     message:
                    //         result.data.reason,
                    //     timeout: 3000,
                    //     icon: 'tim-icons icon-bell-55',
                    //     horizontalAlign: "right",
                    //     verticalAlign: "top",
                    //     type: 'danger'
                    // });
                }
                this.getWarnings()
            })
        },
        savePostReturned() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Da li je za odabrane opomene vraćena pošta?",
                    confirmButtonText: "DA",
                    cancelButtonText: "Odustani",
                    showCancelButton: true
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar

                        const body = {
                            warnings: this.warningTickets
                        }
                        this.loading = true
                        axios.post(this.url + '/ticket/saveMultiplePostReturned', body).then(result => {
                            this.ticketsLoading = false
                            this.loading = false

                            if (result.data.result === 'ok') {
                                this.getWarnings()
                            } else {
                                this.$notify({
                                    message:
                                        result.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        })
                    }
                });
        },
        newWarning1() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Da li želite da generišete nove opomene (OPOMENA 1) za odabrano? Nove opomene će uzeti u obzir samo nenaplaćene doplatne karte. Unesite delovodni broj:",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Delovodni broj" style="width: 100%; height: 50px;"></textarea>`,
                    confirmButtonText: "DA",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar

                        const body = {
                            delovodniBroj: comment,
                            warningType: 0,
                            warnings: this.warningTickets
                        }
                        this.loading = true
                        axios.post(this.url + '/ticket/saveMultipleWarnings', body).then(result => {
                            this.ticketsLoading = false
                            this.loading = false

                            if (result.data.result === 'ok') {
                                (async () => {
                                    for (let i = 0; i < result.data.warnings.length; i++) {
                                        const w = result.data.warnings[i];
                                        console.log("Download: " + w.fileUrl);
                                        const link = document.createElement('a');
                                        link.href = this.fileUrl + "/opomene/" + w.fileUrl;
                                        // Ako želiš da specificiraš ime fajla, postavi atribut download, npr:
                                        // link.download = "fajl.pdf";
                                        link.download = "";
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        // Pauza od 1 sekund između preuzimanja fajlova
                                        await new Promise(resolve => setTimeout(resolve, 1000));
                                        this.getWarnings()

                                    }
                                })();


                            } else {
                                this.$notify({
                                    message:
                                        result.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        })
                    }
                });
        },
        newWarning2() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Da li želite da generišete nove opomene (OPOMENA 2) za odabrano? Nove opomene će uzeti u obzir samo nenaplaćene doplatne karte. Unesite delovodni broj:",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Delovodni broj" style="width: 100%; height: 50px;"></textarea>`,
                    confirmButtonText: "DA",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar

                        const body = {
                            delovodniBroj: comment,
                            warningType: 1,
                            warnings: this.warningTickets
                        }
                        this.loading = true
                        axios.post(this.url + '/ticket/saveMultipleWarnings', body).then(result => {
                            this.ticketsLoading = false
                            this.loading = false

                            if (result.data.result === 'ok') {
                                (async () => {
                                    for (let i = 0; i < result.data.warnings.length; i++) {
                                        const w = result.data.warnings[i];
                                        console.log("Download: " + w.fileUrl);
                                        const link = document.createElement('a');
                                        link.href = this.fileUrl + "/opomene/" + w.fileUrl;
                                        // Ako želiš da specificiraš ime fajla, postavi atribut download, npr:
                                        // link.download = "fajl.pdf";
                                        link.download = "";
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        // Pauza od 1 sekund između preuzimanja fajlova
                                        await new Promise(resolve => setTimeout(resolve, 1000));
                                        this.getWarnings()

                                    }
                                })();


                            } else {
                                this.$notify({
                                    message:
                                        result.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        })
                    }
                });
        },
        izvrsenje() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Da li želite da generišete izvršenje za odabrano? Nove opomene će uzeti u obzir samo nenaplaćene doplatne karte.",
                    html: `
            <input id="invoiceNumber" class="swal2-input" placeholder="Broj fakture">
            <input id="invoiceDate" class="swal2-input" placeholder="Datum izdavanja dd.mm.yyyy.">
        `,
                    confirmButtonText: "DA",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const invoiceNumber = document.getElementById("invoiceNumber").value;
                        const invoiceDate = document.getElementById("invoiceDate").value;

                        if (!invoiceNumber.trim()) {
                            Swal.showValidationMessage("Molimo unesite broj fakture!");
                            return false;
                        }
                        if (!invoiceDate) {
                            Swal.showValidationMessage("Molimo unesite datum izdavanja fakture!");
                            return false;
                        }
                        return { invoiceNumber, invoiceDate };
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const invoiceNumber = result.value.invoiceNumber; // Broj fakture
                        const invoiceDate = result.value.invoiceDate;     // Datum izdavanja (bez sati i minuta)

                        // Kreiramo objekat koji sadrži potrebne podatke
                        const body = {
                            invoice: invoiceNumber,
                            invoiceStamp: invoiceDate,
                            warningType: 2,
                            warnings: this.warningTickets
                        };

                        this.loading = true;
                        axios.post(this.url + '/ticket/saveMultipleWarnings', body).then(result => {
                            this.ticketsLoading = false;
                            this.loading = false;

                            if (result.data.result === 'ok') {
                                (async () => {
                                    for (let i = 0; i < result.data.warnings.length; i++) {
                                        const w = result.data.warnings[i];
                                        console.log("Download: " + w.fileUrl);
                                        const link = document.createElement('a');
                                        link.href = this.fileUrl + "/opomene/" + w.fileUrl;
                                        link.download = "";
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        // Pauza od 1 sekund između preuzimanja fajlova
                                        await new Promise(resolve => setTimeout(resolve, 1000));
                                        this.getWarnings();
                                    }
                                })();
                            } else {
                                this.$notify({
                                    message: result.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        });
                    }
                });

        },
        warningChecked(warning) {
            if (warning.checked) {
                this.warningTickets.push(warning)
                // this.totalWarningTickets+=warning.price
            } else {
                const index = this.warningTickets.indexOf(warning);
                if (index !== -1) {
                    this.warningTickets.splice(index, 1); // Uklanja objekat na datom indeksu
                    // this.totalWarningTickets -= warning.price
                }
            }
        },
        clearStatus() {
            this.filter.status = null
        },
        clearWarningType() {
            this.filter.warningType = null
        },
        changeP(item) {
            this.page = item
            this.getWarnings()
        },
        download() {
            const link = document.createElement('a');
            link.href = this.fileUrl + "/opomene/" + this.warning.fileUrl;
            // Ako želiš da specificiraš ime fajla, postavi atribut download, npr:
            // link.download = "fajl.pdf";
            // Ako ostaviš prazno, browser će pokušati da koristi ime koje je na serveru
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getWarning(w) {
            this.loading = true
            this.warning = {}
            axios.post(this.url + '/ticket/getWarning', w).then(result => {
                this.ticketsLoading = false
                this.loading = false

                if (result.data.result === 'ok') {
                    this.warning = result.data.warning
                    this.showWarning = true

                    this.contractNumber = this.warning.brojKupoprodajnogUgovora || null;
                    this.newOwner = {
                        plates: this.warning.plates,
                        personalNumber: '',
                        lastName: '',
                        name: '',
                        fatherName: '',
                        pib: '',
                        country: '',
                        city: '',
                        address: '',
                        postNumber: '',
                        stamp: new Date().getTime()
                    };

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        cancelWarning(warning) {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Ovo radite u slucaju greske. Nece ponistiti doplatne karte. Molimo vas unesite komentar .",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.comment = comment;
                        this.loading = true
                        warning.comment = comment
                        axios.post(this.url + '/ticket/cancelWarning', warning).then(result => {
                            this.ticketsLoading = false
                            this.loading = false

                            if (result.data.result === 'ok') {
                                this.getWarnings()

                            } else {
                                this.$notify({
                                    message:
                                        result.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        })
                    }
                });
        },
        getWarnings() {
            this.ticketsLoading = true
            this.loading = true
            axios.post(this.url + '/ticket/getWarnings', this.filter).then(result => {
                this.ticketsLoading = false
                this.loading = false

                if (result.data.result === 'ok') {
                    this.warnings = result.data.warnings
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                    this.totalPayed = result.data.totalPayed
                    this.totalCanceled = result.data.totalCanceled

                    this.warningTickets = []

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getWarningsReport() {
            this.ticketsLoading = true
            this.loading = true
            axios.post(this.url + '/ticket/exportWarningsByOwnerAndMonth', this.filter).then(result => {
                this.ticketsLoading = false
                this.loading = false

                if (result.data.result === 'ok') {


                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.upload-area {
    border: 2px dashed #525f7f;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(0, 0, 0, 0.1);
}

.upload-area:hover {
    border-color: #e14eca;
    background: rgba(225, 78, 202, 0.1);
}

.upload-area.drag-over {
    border-color: #00f2c3;
    background: rgba(0, 242, 195, 0.1);
}

.upload-placeholder p {
    margin: 15px 0 5px 0;
    color: #fff;
}

.selected-file {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.file-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.file-name {
    color: #fff;
    font-weight: 500;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 15px;
}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.custom-modal-content-wide {
    background-color: #3b3b5c;
    color: #ffffff;
    border-radius: 8px;
    max-width: 1000px;
    width: 1000px;
}
</style>